import React from 'react';
import './SecondaryHomeImageAsset.css';

const SecondaryHomeImageAsset = () => {
  return (
    <div className="secondary-img-wrapper">
        <img src='/vector_assets/home_ellipses.png' className="secondary-img" />
    </div>
  )
}

export default SecondaryHomeImageAsset;